

const ClientReviewsSlide = ({slideImgClient, clientName, clientPosition , clientReviewDescription }) => {
    return(
        <div className="swiper-slide">
            <div className="client-review-box wow fadeInDown">
                    <p className="review">{clientReviewDescription}</p>
                    <div className="review-owner">
                        <div className="photo-box">
                        <img className="img-fluid"  src={slideImgClient} alt="client phot"/></div>
                        <div className="client-data">
                            <p className="name">{clientName}</p>
                            <p className="job">{clientPosition}</p>
                        </div>
                    </div>      
             </div>
        </div>
    );
    
};
export default ClientReviewsSlide;